import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { Navbar, ContactCTA, Footer } from '../../components';
import styles from './TektronGroup.module.css';

const CL = 'https://res.cloudinary.com/dhjzovpof/image/upload';

const LOGOS = {
  engineering: 'https://res.cloudinary.com/dhjzovpof/image/upload/v1777753953/WhatsApp_Image_2026-05-02_at_8.53.10_PM_kpyeso.jpg',
  thermo:      'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327171/WhatsApp_Image_2026-03-06_at_22.02.15_2_lydvg6.png',
  axillion:    'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327206/WhatsApp_Image_2026-03-21_at_15.36.51_2_e3oggo.png',
  terrafirma:  'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327240/WhatsApp_Image_2026-03-08_at_04.22.57_2_sfov12.png',
};

const SUBSIDIARIES = [
  {
    id: 'engineering',
    name: 'Tektron Engineering',
    logo: LOGOS.engineering,
    logoLabel: 'Tektron Engineering',
    logoLabelColor: '#A61319',
    description:
      'TektronPlus Engineering is our flagship engineering construction subsidiary, delivering road construction, rehabilitation and maintenance, road furniture, road marking and signs, traffic management devices, and renewable energy products. With over a decade of high-stakes delivery, TektronPlus Engineering remains the group\'s core engine of national infrastructure development.',
    visitHref: '/services',
    galleryBg: '#fff',
    galleryRadius: '8px',
    overlay: 'rgba(0,0,0,0.2)',
    images: [
      `${CL}/v1773523578/Frame_1000003454_erzbf7.jpg`,
      `${CL}/v1773523651/Frame_1000003465_ldppty.jpg`,
      `${CL}/v1773523863/19481c9f5990ded5802c8ad8d67ec9596b3c657e_1_nf2zqs.jpg`,
      `${CL}/v1773524604/Frame_1000003454_1_oymu9z.jpg`,
    ],
  },
  {
    id: 'thermo',
    name: 'Tektron Thermo',
    logo: LOGOS.thermo,
    logoLabel: 'Tektron Thermo',
    logoLabelColor: '#A61319',
    description:
      'Tektron Thermo is our manufacturing division, specialising in the production, retail, and exportation of high-grade thermoplastic road marking paint. Our materials are formulated for durability, retro reflectivity, and environmental resistance — meeting international standards and deployed across federal and state highway projects nationwide.',
    visitHref: '/thermo',
    galleryBg: '#fff',
    galleryRadius: '0px',
    overlay: 'rgba(0,0,0,0.1)',
    images: [
      `${CL}/v1773524670/1fae49dd-6f18-4e86-a5f4-9c67c0504cc0_l95vti.jpg`,
      `${CL}/v1773524734/072de619-868c-411f-bc62-8bca67c4eda8_hvorpx.jpg`,
      `${CL}/v1773598115/1b2d7e03-c8ff-4fc8-b97b-b0e27a65da6d_yuw5qi.jpg`,
      `${CL}/v1773598192/aa608c14-d2a0-4d94-8363-db8fed1bcfca_dbhjfa.jpg`,
    ],
  },
  {
    id: 'axillion',
    name: 'AXILLION',
    logo: LOGOS.axillion,
    logoLabel: 'AXILLION',
    logoLabelColor: '#A61319',
    description:
      'AXILLION is our real estate development arm focused on creating modern residential and commercial properties. We deliver developments that balance functional design, structural durability, and long-term investment value — building spaces where communities and businesses thrive.',
    visitHref: '/contact',
    galleryBg: '#F5F5F5',
    galleryRadius: '8px',
    overlay: null,
    images: [
      'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327335/fff3fde5-78aa-4e40-9f70-68355b077793_afcxew.png',
      'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327371/776f35ec-b181-4178-8bac-350805ff7f2b_wldixt.png',
      'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327335/fff3fde5-78aa-4e40-9f70-68355b077793_afcxew.png',
      'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327371/776f35ec-b181-4178-8bac-350805ff7f2b_wldixt.png',
    ],
  },
  {
    id: 'terrafirma',
    name: 'TERRAFIRMA',
    logo: LOGOS.terrafirma,
    logoLabel: 'TERRAFIRMA',
    logoLabelColor: '#A61319',
    logoRadius: '4px',
    description:
      'TERRAFIRMA transforms land into premium residential and commercial spaces. With a commitment to quality construction and sustainable development, TERRAFIRMA builds communities that stand the test of time — delivering properties that represent both lifestyle and lasting value.',
    visitHref: 'https://terrafirma.ng/',
    galleryBg: '#F5F5F5',
    galleryRadius: '8px',
    overlay: null,
    images: [
      'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327405/f12fbbb0-7d52-41f6-bd1c-e3a50beecb8e_oskfmc.png',
      'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327405/f12fbbb0-7d52-41f6-bd1c-e3a50beecb8e_oskfmc.png',
      'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327405/f12fbbb0-7d52-41f6-bd1c-e3a50beecb8e_oskfmc.png',
      'https://res.cloudinary.com/dhjzovpof/image/upload/v1775327405/f12fbbb0-7d52-41f6-bd1c-e3a50beecb8e_oskfmc.png',
    ],
  },
];

const fadeUp = (delay = 0) => ({
  hidden:  { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut', delay } },
});

// ── Subsidiary Gallery ────────────────────────────────────────────────────────
function SubsidiaryGallery({ images, galleryBg, galleryRadius, overlay }) {
  const trackRef = useRef(null);

  const scroll = (dir) => {
    if (!trackRef.current) return;
    const item = trackRef.current.firstChild;
    const w = item ? item.offsetWidth + 8 : 300;
    trackRef.current.scrollBy({ left: dir * w, behavior: 'smooth' });
  };

  return (
    <div className={styles.galleryWrap}>
      <div
        className={styles.galleryInner}
        style={{ background: galleryBg, borderRadius: galleryRadius }}
      >
        <div className={styles.galleryTrack} ref={trackRef}>
          {images.map((src, i) => (
            <div key={i} className={styles.galleryItem}>
              <img src={src} alt="" className={styles.galleryImg} loading="lazy" />
              {overlay && (
                <div className={styles.galleryOverlay} style={{ background: overlay }} aria-hidden="true" />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Desktop nav buttons */}
      <div className={styles.galleryNavRow}>
        <button className={styles.galleryNavBtn} onClick={() => scroll(-1)} aria-label="Previous">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18l-6-6 6-6" stroke="#5e5e5e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <button className={`${styles.galleryNavBtn} ${styles.galleryNavBtnRight}`} onClick={() => scroll(1)} aria-label="Next">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 6l6 6-6 6" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
}

// ── Subsidiary Card ───────────────────────────────────────────────────────────
function SubsidiaryCard({ sub, index }) {
  return (
    <motion.div
        key={index}
      className={styles.subCard}
      variants={fadeUp(0)}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
    >
      {/* Info row */}
      <div className={styles.subInfo}>
        <div className={styles.subLogoBlock}>
          <img
            src={sub.logo}
            alt={sub.name}
            className={styles.subLogo}
            style={{ borderRadius: sub.logoRadius || '0px' }}
          />
          {/*<span className={styles.subLogoLabel} style={{ color: sub.logoLabelColor }}>*/}
          {/*  {sub.logoLabel}*/}
          {/*</span>*/}
        </div>
        <p className={styles.subDesc}>{sub.description}</p>
      </div>

      {/* Gallery */}
      <div className={styles.subGalleryWrap}>
        <SubsidiaryGallery
          images={sub.images}
          galleryBg={sub.galleryBg}
          galleryRadius={sub.galleryRadius}
          overlay={sub.overlay}
        />
      </div>

      {/* Visit site */}
      <a href={sub.visitHref} className={styles.visitLink}>
        Visit Site
      </a>
    </motion.div>
  );
}

// ── Page ──────────────────────────────────────────────────────────────────────
export default function TektronGroup() {
  return (
    <div className={styles.page}>
      <Navbar theme="light" cta="Request Consultancy" ctaTo="/contact" />

      {/* ── HERO ──────────────────────────────────────────── */}
      <section className={styles.hero}>
        <div className={styles.heroGradient} aria-hidden="true" />
        <div className={styles.heroLabel}>
          <h1 className={styles.heroTitle}>TEKTRON GROUP</h1>
        </div>
      </section>

      {/* ── ABOUT ─────────────────────────────────────────── */}
      <motion.section
        className={styles.about}
        variants={fadeUp(0)}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <div className={styles.aboutLeft}>
          <h2 className={styles.aboutHeading}>
            About Tektron Group
          </h2>
        </div>
        <div className={styles.aboutRight}>
          <p className={styles.aboutBody}>
            TektronPlus Group is a diversified organization with operations spanning
            engineering, infrastructure manufacturing, and real estate development.
            The group is built on a commitment to quality, innovation, and national progress.
          </p>
          <p className={styles.aboutBody}>
            Through its specialized subsidiaries —{' '}
            <strong>Tektron Engineering</strong>,{' '}
            <strong>Tektron Thermo</strong>,{' '}
            <strong>AXILLION</strong>, and{' '}
            <strong>TERRAFIRMA</strong>{' '}
            — the group provides a wide range of integrated services, from road construction
            and thermoplastic manufacturing to real estate development across Nigeria.
          </p>
        </div>
      </motion.section>

      {/* ── SUBSIDIARIES ──────────────────────────────────── */}
      <section className={styles.subsidiaries}>
        {SUBSIDIARIES.map((sub, i) => (
          <SubsidiaryCard key={sub.id} sub={sub} index={i} />
        ))}
      </section>

      <ContactCTA />
      <Footer />
    </div>
  );
}
